<template>
  <footer id="layout-footer" style="background: rgb(0,60,100)" class="mt-auto">
    <div class="container">
      <div class="footer-row">
        <div class="footer-meta mx-auto">
          <nav aria-label="Kontakt, Impressum und Zusatzinformationen">
            <ul id="footer-nav" class="menu" v-if="footerLinks">
              <template v-for="item in footerLinks">
                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item" v-if="item.hidden === false" :key="item.id">
                  <router-link :to="item.to" v-if="item.local">{{ $t('comp.footer.' + item.id + '.label') }}</router-link>
                  <a :href="item.url" :target="item.target ||'_self'" v-else>{{ $t('comp.footer.' + item.id + '.label') }}</a>
                </li>
              </template>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { i18nMixin } from '@rrze/vue-bixins'

export default {
  name: 'TheFooter',
  i18nCompName: 'footer',
  i18n: {
    messages: {}
  },
  mixins: [i18nMixin],
  props: {
    footerLinks: {
      default: () => [],
      type: Array
    }
  }
}
</script>
